export const APP_WEB_ROUTES = {
  root: '/',
  login: '/login',
  loans: 'loan-lists',
  loanListCreate: 'loan-lists/create',
  loan: 'loan-lists/:id',
  loanListEdit: 'loan-lists/:id/edit',
  loanDetails: 'loans/:id',
  paymentPlan: 'loans/:id/payment-plan',
  users: '/users',
  notifications: '/notifications',
  settings: '/settings',
  reports: '/reports',
};

export const APP_WEB_PATH = {
  paymentPlan: 'payment-plan',
};
